import { ERROR_TYPE } from "src/constant";

export function getXpath(event: any) {
  let paths: HTMLElement[] = event?.path;
  let ret = '';
  if(event?.composedPath) {
    paths = event.composedPath();
  }
  if(paths && paths.length > 0) {
    ret = paths.reverse().reduce((p, c) => {
      const tagName = c.localName || c.tagName || c.nodeName;
      if(tagName && typeof c.className !== 'undefined') {
        const className = String(c.className).split(/\s+/).join('.');
        const elId = c.id;
        const cp = `${tagName.toLowerCase()}${elId ? `#${elId}` : ''}${className ? `.${className}` : ''}`;
        return p ? `${p}>${cp}` : cp;
      }
      return p;
    }, '');
  }
  return ret;
}

/**
 * 是否为忽略采集的dom内容
 * @param target HTMLElement dom节点
 * @returns boolean
 */
export function isIgnoreDom(target: HTMLElement) {
  const body = document.body;
  if (target && body.contains(target)) {
    const ignore = target.hasAttribute('data-uba-ignore');
    if(ignore) {
      return true;
    }
    return isIgnoreDom(target.parentElement);
  }
  return false;
}
export function getAttributeFromParents(target: HTMLElement, attrName: string, depth = 1) {
  if(target && target.parentElement) {
    const value = target.parentElement.getAttribute(attrName);
    if(value) {
      return value;
    }
    if(depth > 1) {
      return getAttributeFromParents(target.parentElement, attrName, --depth);
    }
  }
  return '';
}

// nodeTitle 获取逻辑顺序：
//  1. 元素节点的`data-uba-title`属性值
//  1. 元素节点的`data-yyy-title`属性值(兼容友云音)
//  1. 元素节点的`title`属性值
//  1. 元素节点的`value`属性值
//  1. 元素节点的`alt`属性值
//  1. 元素节点的内容（包含子节点）字符长度超出50截断，无任务内容时，再往上1级获取
export function getNodeTitle(target: HTMLElement) {
  const attrKeys = ['data-uba-title', 'data-yyy-title', 'title'];
  const attrKeys2 = ['value', 'alt'];
  let ret = '';
  let ctarget = target;
  if(!ctarget) {return '';}

  // 兼容shadow场景
  const isShadow = !!target.shadowRoot;
  if(isShadow) {
    ctarget = target.shadowRoot.activeElement as HTMLElement;
    if(!ctarget) {return '';}
  }
  // 优先获取当前节点的['data-uba-title', 'data-yyy-title', 'title']属性
  attrKeys.find(key => {
    const tit = ctarget.getAttribute(key);
    if(tit) {
      ret = tit;
    }
    return !!tit;
  });
  // 查找当前节点往上2级节点的'data-uba-title', 'title']属性
  if(!ret) {
    const ptits = getParentNodeAttrs(['data-uba-title', 'title'], ctarget, 2);
    if(ptits && ptits.length > 0) {
      ret = ptits.pop();
    }
  }
  // 查找当前节点的['value', 'alt']属性
  if(!ret) {
    attrKeys2.find(key => {
      const tit = ctarget.getAttribute(key);
      if(tit) {
        ret = tit;
      }
      return !!tit;
    });
  }
  // 获取当前节点的text内容，无内容时会上升一个层级获取
  if(!ret) {
    const innerText = ctarget.innerText || ctarget.parentElement?.innerText || '';
    if(!/\n/.test(innerText)) {
      ret = innerText.slice(0, 20);
    }
  }
  return ret;
}

export function getParentNodeAttrs(attrs: string[], target: HTMLElement, limitDep?: number): string[] {
  const attrKeys = attrs;
  const ret = [];
  let dep = 1;
  let cNode = target.parentElement;
  const isShadow = !!target.shadowRoot;
  // 当前点击结点为shadow场景时
  if(isShadow) {
    cNode = target.shadowRoot.activeElement as HTMLElement;
  }
  const body = document.body;
  while (body.contains(cNode) || (isShadow && cNode)) {
    if(limitDep > 0 && dep > limitDep) {
      break;
    }
    attrKeys.find(key => {
      const ctit = cNode?.getAttribute(key);
      if (ctit) {
        ret.push(ctit);
        return true;
      }
      return false;
    });
    cNode = cNode.parentElement;
    dep = dep + 1;
  }
  return ret.reverse();
}
// 指定节点的父级title属性自定义设置链，从上往下返回获取到的所有titie值
export function getParentNodeTitles(target: HTMLElement): string[] {
  const attrKeys = ['data-uba-title', 'data-yyy-title'];
  const ret = [];
  let cNode = target.parentElement;
  const isShadow = !!target.shadowRoot;
  // 当前点击结点为shadow场景时
  if(isShadow) {
    cNode = target.shadowRoot.activeElement as HTMLElement;
  }

  while (cNode) {
    // 弹窗逻辑兼容处理，获取弹窗标题
    if(/wui-modal-dialog/.test(cNode.className)) {
      const modalTitleEl = cNode.querySelector('.wui-modal-title') as HTMLElement;
      const modalConfirmTitleEl = cNode.querySelector('.ac-confirm-body-title-keyword') as HTMLElement;
      let modalTitle = modalTitleEl?.innerText || modalConfirmTitleEl?.innerText;
      if(!modalTitle) {
        modalTitle = cNode.innerText.split('\n')[0];
      }
      ret.push(modalTitle);
    }
    attrKeys.find(key => {
      const ctit = cNode?.getAttribute(key);
      if (ctit) {
        ret.push(ctit);
        return true;
      }
      return false;
    });
    cNode = cNode.parentElement;
  }
  return ret.reverse();
}

export function geErrorEventType(err: ErrorEvent): string {
  let errorName = err.error?.name;
  const targetNodeName = (<Node>err.target).nodeName;
  if (!errorName) {
    const matchs = err.message?.match(/^Uncaught (\w+):/) || [];
    errorName = matchs[1];
  }
  // React 错误
  if (/Minified React error/i.test(err.message)) {
    errorName = ERROR_TYPE.ReactError;
  }
  if(targetNodeName === 'LINK' || targetNodeName === 'SCRIPT') {
    errorName = ERROR_TYPE.ResourceError;
  }

  return errorName || ERROR_TYPE.Unknown;
}

export function getNodeAttrs(target: Node): Record<string, unknown> {
  const attrKey = 'data-uba-attrs';
  const nodeAttr = {};
  const parentAttr = {};
  const body = document.body;

  if(target && target.parentNode && body.contains(target.parentNode)) {
    Object.assign(parentAttr, getNodeAttrs(target.parentNode));
  }
  const attrsStr = (<HTMLElement>target)?.getAttribute(attrKey);
  if (/^\{.*\}$/.test(attrsStr)) {
    try {
      Object.assign(nodeAttr, JSON.parse(attrsStr));
    } catch (error) {
      hbLogger.warn(`${attrKey} is invalid JSON string`, error);
    }
  }

  return {
    ...parentAttr,
    ...nodeAttr,
  };
}

export function getNodeFieldid(target: HTMLElement) {
  const curFieldid = target?.getAttribute('fieldid');
  if(curFieldid) {
    return curFieldid;
  }
  const fieldids = getParentNodeAttrs(['fieldid'], target, 3);
  return fieldids.pop();
}
